import React, { useState } from 'react';
import './TransactionHistory.css';

const TransactionHistory = () => {
    const [filter, setFilter] = useState('all');
    const [searchTerm, setSearchTerm] = useState('');

    // Sample transaction data for virtual card
    const transactions = [
        {
            id: 1,
            type: 'payment',
            merchant: 'Amazon.com',
            category: 'Online Shopping',
            amount: 156.89,
            currency: 'USD',
            date: '2024-12-11 18:45:32',
            status: 'completed',
            cardLast4: '2109',
            location: 'United States'
        },
        {
            id: 2,
            type: 'payment',
            merchant: 'Netflix Subscription',
            category: 'Entertainment',
            amount: 15.99,
            currency: 'USD',
            date: '2024-12-10 09:15:18',
            status: 'completed',
            cardLast4: '2109',
            location: 'Netherlands'
        },
        {
            id: 3,
            type: 'refund',
            merchant: 'Steam Games',
            category: 'Digital Services',
            amount: 59.99,
            currency: 'USD',
            date: '2024-12-09 14:22:05',
            status: 'completed',
            cardLast4: '2109',
            location: 'United States'
        },
        {
            id: 4,
            type: 'payment',
            merchant: 'Uber Ride',
            category: 'Transportation',
            amount: 28.50,
            currency: 'USD',
            date: '2024-12-08 22:30:45',
            status: 'completed',
            cardLast4: '2109',
            location: 'Canada'
        },
        {
            id: 5,
            type: 'payment',
            merchant: 'Apple iTunes',
            category: 'Digital Services',
            amount: 9.99,
            currency: 'USD',
            date: '2024-12-08 11:05:12',
            status: 'completed',
            cardLast4: '2109',
            location: 'Ireland'
        },
        {
            id: 6,
            type: 'payment',
            merchant: 'Spotify Premium',
            category: 'Entertainment',
            amount: 12.99,
            currency: 'USD',
            date: '2024-12-07 08:00:00',
            status: 'completed',
            cardLast4: '2109',
            location: 'Sweden'
        },
        {
            id: 7,
            type: 'payment',
            merchant: 'OpenAI ChatGPT Plus',
            category: 'Software & Services',
            amount: 20.00,
            currency: 'USD',
            date: '2024-12-06 16:20:33',
            status: 'completed',
            cardLast4: '2109',
            location: 'United States'
        },
        {
            id: 8,
            type: 'declined',
            merchant: 'Unknown Merchant',
            category: 'Suspicious Activity',
            amount: 299.99,
            currency: 'USD',
            date: '2024-12-05 23:45:10',
            status: 'declined',
            cardLast4: '2109',
            location: 'Unknown'
        },
        {
            id: 9,
            type: 'payment',
            merchant: 'GitHub Pro Subscription',
            category: 'Software & Services',
            amount: 7.00,
            currency: 'USD',
            date: '2024-12-05 15:30:00',
            status: 'completed',
            cardLast4: '2109',
            location: 'United States'
        },
        {
            id: 10,
            type: 'payment',
            merchant: 'Adobe Creative Cloud',
            category: 'Software & Services',
            amount: 54.99,
            currency: 'USD',
            date: '2024-12-04 10:12:25',
            status: 'completed',
            cardLast4: '2109',
            location: 'United States'
        },
        {
            id: 11,
            type: 'payment',
            merchant: 'Booking.com Hotel',
            category: 'Travel',
            amount: 234.50,
            currency: 'USD',
            date: '2024-12-03 19:45:50',
            status: 'completed',
            cardLast4: '2109',
            location: 'Netherlands'
        },
        {
            id: 12,
            type: 'refund',
            merchant: 'Zara Online Store',
            category: 'Online Shopping',
            amount: 89.90,
            currency: 'USD',
            date: '2024-12-02 13:20:18',
            status: 'completed',
            cardLast4: '2109',
            location: 'Spain'
        },
        {
            id: 13,
            type: 'payment',
            merchant: 'Microsoft Azure',
            category: 'Cloud Services',
            amount: 125.00,
            currency: 'USD',
            date: '2024-12-01 07:00:00',
            status: 'completed',
            cardLast4: '2109',
            location: 'United States'
        },
        {
            id: 14,
            type: 'payment',
            merchant: 'Starbucks Coffee',
            category: 'Food & Dining',
            amount: 8.75,
            currency: 'USD',
            date: '2024-11-30 08:30:15',
            status: 'completed',
            cardLast4: '2109',
            location: 'Canada'
        },
        {
            id: 15,
            type: 'payment',
            merchant: 'Google Workspace',
            category: 'Software & Services',
            amount: 12.00,
            currency: 'USD',
            date: '2024-11-29 00:05:00',
            status: 'completed',
            cardLast4: '2109',
            location: 'United States'
        }
    ];

    const filteredTransactions = transactions.filter(transaction => {
        const matchesFilter = filter === 'all' || transaction.type === filter;
        const matchesSearch = transaction.merchant.toLowerCase().includes(searchTerm.toLowerCase()) ||
            transaction.category.toLowerCase().includes(searchTerm.toLowerCase());
        return matchesFilter && matchesSearch;
    });

    const getTransactionIcon = (type) => {
        switch (type) {
            case 'payment':
                return (
                    <svg viewBox="0 0 24 24" width="24" height="24" className="transaction-icon payment">
                        <path d="M19 14V6c0-1.1-.9-2-2-2H3c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zm-9-1c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm13-6v11c0 1.1-.9 2-2 2H4v-2h17V7h2z" />
                    </svg>
                );
            case 'refund':
                return (
                    <svg viewBox="0 0 24 24" width="24" height="24" className="transaction-icon refund">
                        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm4.59-12.42L10 14.17l-2.59-2.58L6 13l4 4 8-8z" />
                    </svg>
                );
            case 'declined':
                return (
                    <svg viewBox="0 0 24 24" width="24" height="24" className="transaction-icon declined">
                        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" />
                    </svg>
                );
            default:
                return null;
        }
    };

    const getStatusBadge = (status) => {
        const statusClasses = {
            completed: 'status-badge success',
            pending: 'status-badge warning',
            declined: 'status-badge error'
        };
        return <span className={statusClasses[status]}>{status}</span>;
    };

    const getTotalAmount = () => {
        return filteredTransactions
            .filter(t => t.type === 'payment' && t.status === 'completed')
            .reduce((sum, t) => sum + t.amount, 0);
    };

    const getRefundAmount = () => {
        return filteredTransactions
            .filter(t => t.type === 'refund' && t.status === 'completed')
            .reduce((sum, t) => sum + t.amount, 0);
    };

    return (
        <div className="transaction-history-container">
            <div className="transaction-header">
                <div className="header-title-section">
                    <h2>Transaction History</h2>
                    <p className="header-subtitle">Virtual Card Activity</p>
                </div>

                <div className="header-stats">
                    <div className="stat-card spent">
                        <span className="stat-label">Total Spent</span>
                        <span className="stat-value">${getTotalAmount().toFixed(2)}</span>
                    </div>
                    <div className="stat-card refunded">
                        <span className="stat-label">Total Refunded</span>
                        <span className="stat-value">${getRefundAmount().toFixed(2)}</span>
                    </div>
                    <div className="stat-card transactions">
                        <span className="stat-label">Transactions</span>
                        <span className="stat-value">{filteredTransactions.length}</span>
                    </div>
                </div>
            </div>

            <div className="transaction-controls">
                <div className="search-bar">
                    <svg viewBox="0 0 24 24" width="20" height="20" className="search-icon">
                        <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" />
                    </svg>
                    <input
                        type="text"
                        placeholder="Search by merchant or category..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        className="search-input"
                    />
                </div>

                <div className="filter-buttons">
                    <button
                        className={`filter-btn ${filter === 'all' ? 'active' : ''}`}
                        onClick={() => setFilter('all')}
                    >
                        All
                    </button>
                    <button
                        className={`filter-btn ${filter === 'payment' ? 'active' : ''}`}
                        onClick={() => setFilter('payment')}
                    >
                        Payments
                    </button>
                    <button
                        className={`filter-btn ${filter === 'refund' ? 'active' : ''}`}
                        onClick={() => setFilter('refund')}
                    >
                        Refunds
                    </button>
                    <button
                        className={`filter-btn ${filter === 'declined' ? 'active' : ''}`}
                        onClick={() => setFilter('declined')}
                    >
                        Declined
                    </button>
                </div>
            </div>

            <div className="transactions-list">
                {filteredTransactions.length > 0 ? (
                    filteredTransactions.map((transaction) => (
                        <div key={transaction.id} className={`transaction-item ${transaction.type}`}>
                            <div className="transaction-icon-wrapper">
                                {getTransactionIcon(transaction.type)}
                            </div>

                            <div className="transaction-details">
                                <div className="transaction-main">
                                    <h4 className="merchant-name">{transaction.merchant}</h4>
                                    <span className="transaction-category">{transaction.category}</span>
                                </div>
                                <div className="transaction-meta">
                                    <span className="transaction-date">{transaction.date}</span>
                                    <span className="transaction-location">
                                        <svg viewBox="0 0 24 24" width="14" height="14">
                                            <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
                                        </svg>
                                        {transaction.location}
                                    </span>
                                    <span className="card-number">Card ••••{transaction.cardLast4}</span>
                                </div>
                            </div>

                            <div className="transaction-right">
                                <div className="transaction-amount">
                                    <span className={`amount ${transaction.type === 'refund' ? 'positive' : transaction.type === 'declined' ? 'declined' : 'negative'}`}>
                                        {transaction.type === 'refund' ? '+' : transaction.type === 'declined' ? '' : '-'}
                                        {transaction.currency} {transaction.amount.toFixed(2)}
                                    </span>
                                </div>
                                {getStatusBadge(transaction.status)}
                            </div>
                        </div>
                    ))
                ) : (
                    <div className="no-transactions">
                        <svg viewBox="0 0 24 24" width="64" height="64">
                            <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zM7 10h2v7H7zm4-3h2v10h-2zm4 6h2v4h-2z" />
                        </svg>
                        <p>No transactions found</p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default TransactionHistory;